import * as breakpoints from "./breakpoints";
import * as color from "./color";
import * as common from "./common";

const theme = {
  breakpoints: {
    values: {
      ...breakpoints,
    },
  },
  color: color,
  common: common,
};

export type Theme = typeof theme;
export type ThemeProps = { theme: Theme };

export default theme;
